module.exports = __webpack_public_path__ + "static/img/bz-bg.9ebb2d63.png";